import {svgIconWrapper} from '../svg-icon-wrapper';

import JotformRegular from './jotform-regular-icon.svg';

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
    const {fill: _fill, color: _color, ...rest} = props;

    return <JotformRegular {...rest} />;
}

SvgComponent.iconName = 'jotformRegular';

export const JotformRegularIcon = svgIconWrapper(SvgComponent);
